/*
  Our own Buy Now, in place of Fastrr's.

  Fastrr's button opened Fastrr's checkout, which is a different shop from
  the one the app is: different address book, different discounts, different
  gift. This one does exactly what the app's Buy Now does
  (handleBuyNow in src/screens/ProductDetailScreen.tsx) — puts the chosen
  variant in the basket and goes straight to our checkout.

  Shopify's own online-store cart (/cart/add.js), the same basket every
  "Add to cart" button on the shop already fills, so the header count and
  everything else stay right.
*/
(function () {
  'use strict';

  var CHECKOUT_URL = '/pages/checkout?view=sp-checkout';

  function formFor(button) {
    return (button.closest && button.closest('form[action*="/cart/add"]')) ||
      document.querySelector('form[action*="/cart/add"]');
  }

  // Anything the shop writes onto the line — a delivery preference from the
  // pincode box, for one — travels with it, exactly as it would through the
  // ordinary Add to cart.
  function propertiesFrom(form) {
    var properties = {};
    if (!form) return properties;
    form.querySelectorAll('[name^="properties["]').forEach(function (field) {
      if (field.disabled) return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      var name = field.getAttribute('name');
      var key = name.slice('properties['.length, name.length - 1);
      if (key && field.value) properties[key] = field.value;
    });
    return properties;
  }

  function fail(button, message) {
    button.removeAttribute('aria-busy');
    button.disabled = false;
    button.querySelector('.sp-buy__text').textContent = 'BUY NOW';
    var note = button.parentNode.querySelector('.sp-buy__error');
    if (!note) {
      note = document.createElement('p');
      note.className = 'sp-buy__error';
      button.parentNode.insertBefore(note, button.nextSibling);
    }
    note.textContent = message;
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var button = event.target.closest('[data-sp-buy-now]');
    if (!button) return;

    event.preventDefault();
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    var form = formFor(button);
    var field = form && form.querySelector('[name="id"]');
    var variantId = field && field.value;
    if (!variantId) {
      // No variant settled yet — the size or colour is still open, and the
      // product page's own picker is where that is answered.
      fail(button, 'Please choose an option above first.');
      return;
    }

    var quantityField = form && form.querySelector('[name="quantity"]');
    var quantity = Math.max(1, parseInt(quantityField && quantityField.value, 10) || 1);

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.querySelector('.sp-buy__text').textContent = 'Please wait…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity, properties: propertiesFrom(form) }]
      })
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw new Error(json.description || json.message || 'Could not add that.');
          return json;
        });
      })
      .then(function () {
        window.location.href = CHECKOUT_URL;
      })
      .catch(function (err) {
        fail(button, err.message || 'Could not add that. Please try again.');
      });
  });
})();
